import React from 'react'
let PropTypes = React.PropTypes

import Modal from 'react-bootstrap/lib/Modal.js'

import classNames from 'classnames/bind'
import * as css from './Modales.css'
let cx = classNames.bind(css)

export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = {visible: false}
        let self = this
        this.show = ()=>
            self.setState({visible: true})
        this.hide = ()=>{
            self.setState({visible: false})
        }
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}

export class ModalReporteInicial extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            marcas: {
                idInventario: this.props.idInventario,
                tipo: 1,
                hora: '',
                dotacion: 0,
                avance: 0,
                error: 0,
                comentario: '',
                auditoria: 0,
                idDescripcionReportesIG: null,
                idDescripcionReportesLocal: null
            },
            error: '',
            enviando: false,
            descripcionesIG: [],
            descripcionesLocal: [],
            defaulttext: "",
            rows: 2,
        }    
        this.onHoraChange = (evt)=>{
            this.setState({ marcas: Object.assign({}, this.state.marcas, {hora: evt.target.value}) })
        }
        this.onDotacionChange = (evt)=>{
            this.setState({ marcas: Object.assign({}, this.state.marcas, {dotacion: evt.target.value}) })
        }
        this.onComentarioIGChange =(evt)=>{
            this.setState({ marcas: Object.assign({}, this.state.marcas, {idDescripcionReportesIG: evt.target.value}) })
        }        
        this.onComentarioLocalChange =(evt)=>{
            this.setState({ marcas: Object.assign({}, this.state.marcas, {idDescripcionReportesLocal: evt.target.value}) })
        }
        this.handleChange =(evt)=>{
            this.setState({ marcas: Object.assign({}, this.state.marcas, {comentario: evt.target.value}) })
            const currentRows = evt.target.scrollHeight / 17;
            if (currentRows <= 5) {
                this.setState({ rows: currentRows });
            }
        }
        this.horaInicial = ()=>{
            var horas = new Date().getHours()
            var minutos = new Date().getMinutes()
            if (horas < 10)
                horas = '0' + horas

            if (minutos < 10)
                minutos = '0' + minutos

            this.setState({ marcas: Object.assign({}, this.state.marcas, {hora: horas + ':' + minutos}) })
        }
        this.fetchDescripcionesReportes = ()=>{
            this.context.descripcionReportes(1,1)
                .then(resp=>{
                    console.log(resp)
                    this.setState({ descripcionesIG: resp.result })
                })
                .catch(err=>{
                    console.log(err)
                })
            
            this.context.descripcionReportes(1,2)
                .then(resp=>{
                    this.setState({ descripcionesLocal: resp.result })
                    console.log(resp)
                })
                .catch(err=>{
                    console.log(err)
                })
        }
        this.handleSubmit = (evt)=>{
            evt.preventDefault()
            evt.stopPropagation()
            this.setState({ enviando: true })
            if (this.state.marcas.hora && this.state.marcas.dotacion > 0 && this.state.marcas.idDescripcionReportesLocal && this.state.marcas.idDescripcionReportesIG){
                this.context.nuevaMarca(this.state.marcas)
                    .then(resp=>{
                        this.props.hideModal()
                    })
                    .catch(err=>{
                        console.log(err)
                        this.setState({
                            error: err.data.error,
                            enviando: false
                        })
                    })
            }else{
                this.setState({
                    error: 'Complete todos los campos.',
                    enviando: false
                })
            }
        }
    }
    componentWillMount(){
        this.horaInicial()
        this.fetchDescripcionesReportes()
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>Reportar Inicio</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        {this.state.error && <div className="alert alert-danger" role="alert">{this.state.error}</div>}
                        <form className="col-md-12 col-sm-12 form-horizontal" action="" onSubmit={this.state.enviando? null : this.handleSubmit}>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                <label className="col-sm-2 control-label">Hora</label>
                                <div className="col-sm-3">
                                    <input type="time" className="form-control" placeholder="Hora"
                                        value={this.state.marcas.hora} onChange={this.onHoraChange}
                                    />
                                </div>
                            </div>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                <label className="col-sm-2 control-label">Dotación</label>
                                <div className="col-sm-3">
                                    <input type="number" min={0} className="form-control" placeholder="Dotación"
                                        value={this.state.marcas.dotacion} onChange={this.onDotacionChange}
                                    />
                                </div>
                            </div>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                <label className="col-sm-2 control-label">Comentario IG</label>
                                <div className="col-sm-10">
                                    <SelectorComentarioPrimero
                                        idComentario={this.state.marcas.idDescripcionReportesIG}
                                        comentarioChange={this.onComentarioIGChange}
                                        comentarios={this.state.descripcionesIG}
                                    />
                                </div>
                            </div>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                <label className="col-sm-2 control-label">Comentario Local</label>
                                <div className="col-sm-10">
                                    <SelectorComentarioPrimero
                                        idComentario={this.state.marcas.idDescripcionReportesLocal}
                                        comentarioChange={this.onComentarioLocalChange}
                                        comentarios={this.state.descripcionesLocal}
                                    />
                                </div>
                            </div>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                <label className="col-sm-2 control-label">Comentarios Adicionales</label>
                                <div className="col-sm-10">
                                    <textarea
                                        ref={(text) => this.textArea = text}
                                        onChange={this.handleChange}
                                        value={this.state.marcas.comentario}
                                        maxLength={500}
                                        rows={this.state.rows}
                                        type="text"
                                        name="comentarios"
                                    />
                                </div>
                            </div>
                            <div className={cx("col-md-10 form-group", 'form__control-label')}>
                                <button className={cx("col-md-6 btn btn-block btn-primary", 'btn-50-perc')} type="submit" disabled={this.state.enviando}>{this.state.enviando? 'Enviando Reporte' : 'Enviar Reporte'}</button>
                                <a className={cx("col-md-4 btn btn-block btn-default", 'btn-50-perc')} href="#" onClick={this.state.enviando? null : this.props.hideModal}>Cancelar</a>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}
ModalReporteInicial.contextTypes = {
    nuevaMarca: PropTypes.func,
    descripcionReportes: PropTypes.func
}
export class ModalReporteAvance extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            marcas: {
                idInventario: this.props.idInventario,
                tipo: 2,
                hora: '',
                dotacion: this.props.dotacion,
                avance: 0,
                error: 0,
                comentario: '',
                auditoria: 0,
                idDescripcionReportesIG: null,
                idDescripcionReportesLocal: null
            },
            error: '',
            enviando: false,
            warningAI: '',
            warningError: '',
            defaulttext: "",
            rows: 2,
        }
        this.onHoraChange = (evt)=>{
            this.setState({ marcas: Object.assign({}, this.state.marcas, {hora: evt.target.value}) })
        }
        this.onAvanceChange = (evt)=>{
            this.setState({ marcas: Object.assign({}, this.state.marcas, {avance: evt.target.value}) })
        }
        this.onErrorChange = (evt)=>{
            this.setState({ marcas: Object.assign({}, this.state.marcas, {error: evt.target.value}) })
        }
        this.onAuditoriaChange = (evt)=>{
            this.setState({ 
                warningAI: evt.target.value < 25? 'Insuficiente' : '',
                warningError: evt.target.value < 25? 'No representativo' : ''
            })
            this.setState({ marcas: Object.assign({}, this.state.marcas, {auditoria: evt.target.value}) })
        }
        this.horaInicial = ()=>{
            var horas = new Date().getHours()
            var minutos = new Date().getMinutes()
            if (horas < 10)
                horas = '0' + horas

            if (minutos < 10)
                minutos = '0' + minutos

            this.setState({ marcas: Object.assign({}, this.state.marcas, {hora: horas + ':' + minutos}) })
        }
        this.handleChange =(evt)=>{
            this.setState({ marcas: Object.assign({}, this.state.marcas, {comentario: evt.target.value}) })
            const currentRows = evt.target.scrollHeight / 17;
            if (currentRows <= 5) {
                this.setState({ rows: currentRows });
            }
        }
        this.handleSubmit = (evt)=>{
            evt.preventDefault()
            evt.stopPropagation()
            this.setState({ enviando: true })
            if (this.state.marcas.hora && this.state.marcas.avance && this.state.marcas.error && this.state.marcas.auditoria){
                if (this.state.marcas.error > 4 || this.state.marcas.avance > 100 || this.state.marcas.auditoria > 100){
                    this.setState({
                        error: 'Existen campos con error.',
                        enviando: false
                    })
                }else{
                    this.context.nuevaMarca(this.state.marcas)
                        .then(resp=>{
                            this.props.hideModal()
                        })
                        .catch(err=>{
                            this.setState({
                                error: err.data.error,
                                enviando: false
                            })
                        })
                }    
            }else{
                this.setState({
                    error: 'Complete todos los campos.',
                    enviando: false
                })
            }
        }
    }
    componentWillMount(){
        this.horaInicial()
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>Reportar Avance</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        {this.state.error && <div className="alert alert-danger" role="alert">{this.state.error}</div>}
                        <form className="col-md-12 col-sm-12 form-horizontal" action="" onSubmit={this.state.enviando? null : this.handleSubmit}>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                <label className="col-sm-2 control-label">Hora</label>
                                <div className="col-sm-4">
                                    <input type="time" className="form-control" placeholder="Hora"
                                        value={this.state.marcas.hora} onChange={this.onHoraChange}
                                    />
                                </div>
                            </div>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                <label className="col-sm-2 control-label">Avance</label>
                                <div className="col-sm-4">
                                    <input type="number" step={0.1} max={100} min={0} className="form-control" placeholder="Avance"
                                        value={this.state.marcas.avance} onChange={this.onAvanceChange}
                                    />
                                </div>
                            </div>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                <label className="col-sm-2 control-label">Auditoria</label>
                                <div className="col-sm-4">
                                    <input type="number" step={0.1} max={100} min={0} className="form-control" placeholder="Auditoria"
                                        value={this.state.marcas.auditoria} onChange={this.onAuditoriaChange}
                                    />
                                    {this.state.warningAI && <div className={cx("alert alert-warning", 'warning-custom')} role="alert">{this.state.warningAI}</div>}
                                </div>
                                <label className="col-sm-2 control-label">Error</label>
                                <div className="col-sm-4">
                                    <input type="number" step={0.1} max={4} min={0} className="form-control" placeholder="Error"
                                        value={this.state.marcas.error} onChange={this.onErrorChange}
                                    />
                                    {this.state.warningError && <div className={cx("alert alert-warning", 'warning-custom')} role="alert">{this.state.warningError}</div>}
                                </div>
                            </div>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                <label className="col-sm-2 control-label">Comentarios Adicionales</label>
                                <div className="col-sm-10">
                                    <textarea
                                        ref={(text) => this.textArea = text}
                                        onChange={this.handleChange}
                                        value={this.state.marcas.comentario}
                                        maxLength={500}
                                        rows={this.state.rows}
                                        type="text"
                                        name="comentarios"
                                    />
                                </div>
                            </div>
                            <div className={cx("col-md-10 form-group", 'form__control-label')}>
                                <button className={cx("col-md-6 btn btn-block btn-primary", 'btn-50-perc')} type="submit" disabled={this.state.enviando}>{this.state.enviando? 'Enviando Reporte' : 'Enviar Reporte'}</button>
                                <a className={cx("col-md-4 btn btn-block btn-default", 'btn-50-perc')} href="#" onClick={this.state.enviando? null : this.props.hideModal}>Cancelar</a>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}
ModalReporteAvance.contextTypes = {
    nuevaMarca: PropTypes.func,
    descripcionReportes: PropTypes.func
}
export class ModalReporteFinal extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            marcas: {
                idInventario: this.props.idInventario,
                tipo: 3,
                hora: '',
                dotacion: this.props.dotacion,
                avance: 0,
                error: 0,
                comentario: '',
                auditoria: 0,
                idDescripcionReportesIG: null,
                idDescripcionReportesLocal: null
            },
            error: '',
            enviando: false,
            descripcionesIG: [],
            descripcionesCheckList: [],
            deterioro: false,
            cancelado: false,
            cantDeterioros: 1,
            deterioros: [],
            defaulttext: "",
            rows: 2,
        }
        this.createInputDeterioros = ()=>{
            const deterioros = []
            for (let index = 0; index < this.state.cantDeterioros; index++){
                deterioros[index] = {id: index, sku:"", cancelado: false}
            }
            this.setState({deterioros})
        }
        this.onHoraChange = (evt)=>{
            this.setState({ marcas: Object.assign({}, this.state.marcas, {hora: evt.target.value}) })
        }
        this.onComentarioIGChange =(evt)=>{
            this.setState({ marcas: Object.assign({}, this.state.marcas, {idDescripcionReportesIG: evt.target.value}) })
        }        
        this.onComentarioCheckListChange =(evt)=>{
            this.setState({ marcas: Object.assign({}, this.state.marcas, {idDescripcionReportesLocal: evt.target.value}) })
        }
        this.onDeterioroChange = (evt)=>{
            this.setState({ 
                deterioro: !this.state.deterioro,
                cancelado: false
            })
            this.createInputDeterioros()
        }
        this.onCantDeterioroChange = (evt)=>{
            this.setState({cantDeterioros: evt.target.value}, ()=> this.createInputDeterioros())
            
        }
        this.onSKUChange = (evt)=>{
            evt.preventDefault()
            evt.persist()
            const nuevoDeterioro = this.state.deterioros
            nuevoDeterioro[evt.target.id].sku = evt.target.value
            this.setState({ deterioros: nuevoDeterioro })
        }
        this.onCanceladoChange = (evt)=>{
            this.setState({ cancelado: !this.state.cancelado })
        }
        this.horaInicial = ()=>{
            var horas = new Date().getHours()
            var minutos = new Date().getMinutes()
            if (horas < 10)
                horas = '0' + horas

            if (minutos < 10)
                minutos = '0' + minutos

            this.setState({ marcas: Object.assign({}, this.state.marcas, {hora: horas + ':' + minutos}) })
        }
        this.fetchDescripcionesReportes = ()=>{
            this.context.descripcionReportes(3,1)
                .then(resp=>{
                    console.log(resp)
                    this.setState({ descripcionesIG: resp.result })
                })
                .catch(err=>{
                    console.log(err)
                })
            
            this.context.descripcionReportes(3,2)
                .then(resp=>{
                    this.setState({ descripcionesCheckList: resp.result })
                    console.log(resp)
                })
                .catch(err=>{
                    console.log(err)
                })
        }
        this.handleChange =(evt)=>{
            this.setState({ marcas: Object.assign({}, this.state.marcas, {comentario: evt.target.value}) })
            const currentRows = evt.target.scrollHeight / 17;
            if (currentRows <= 5) {
                this.setState({ rows: currentRows });
            }
        }
        this.handleSubmit = (evt)=>{
            evt.preventDefault()
            evt.stopPropagation()
            this.setState({ enviando: true })
            var skuVacio = false
            this.state.deterioros.map((deterioro)=>{
                if (deterioro.sku === "" && this.state.deterioro) {
                    skuVacio = true
                }
            })
            if (this.state.marcas.hora && this.state.marcas.idDescripcionReportesIG && this.state.marcas.idDescripcionReportesLocal && skuVacio == false){
                if (this.state.marcas.error > 4 || this.state.marcas.avance > 100 || this.state.marcas.auditoria > 100){
                    this.setState({
                        error: 'Existen campos con error.',
                        enviando: false
                    })
                }else{
                    this.context.nuevaMarca(this.state.marcas)
                        .then(resp=>{
                            this.state.deterioros.map((deterioro)=>{
                                this.context.nuevoAnexoMarca(resp.msg, true, deterioro.sku, this.state.cancelado, null)
                            })
                            this.props.hideModal()
                        })
                        .catch(err=>{
                            this.setState({
                                error: err.data,
                                enviando: false
                            })
                        })
                }
            }else{
                this.setState({
                    error: 'Complete todos los campos.',
                    enviando: false
                })
            }
        }
    }
    componentWillMount(){
        this.horaInicial()
        this.fetchDescripcionesReportes()
        this.createInputDeterioros()
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>Reportar Término</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        {this.state.error && <div className="alert alert-danger" role="alert">{this.state.error}</div>}
                        <form className="col-md-12 col-sm-12 form-horizontal" action="" onSubmit={this.state.enviando? null : this.handleSubmit}>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                <label className="col-sm-2 control-label">Hora</label>
                                <div className="col-sm-3">
                                    <input type="time" className="form-control" placeholder="Hora"
                                        value={this.state.marcas.hora} onChange={this.onHoraChange}
                                    />
                                </div>
                            </div>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                <label className="col-sm-2 control-label">Comentario IG</label>
                                <div className="col-sm-10">
                                    <SelectorComentarioPrimero
                                        idComentario={this.state.marcas.idDescripcionReportesIG}
                                        comentarioChange={this.onComentarioIGChange}
                                        comentarios={this.state.descripcionesIG}
                                    />
                                </div>
                            </div>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                <label className="col-sm-2 control-label">Comentario CheckList</label>
                                <div className="col-sm-10">
                                    <SelectorComentarioPrimero
                                        idComentario={this.state.marcas.idDescripcionReportesLocal}
                                        comentarioChange={this.onComentarioCheckListChange}
                                        comentarios={this.state.descripcionesCheckList}
                                    />
                                </div>
                            </div>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                <label className="col-sm-2 control-label">Comentarios Adicionales</label>
                                <div className="col-sm-10">
                                    <textarea
                                        ref={(text) => this.textArea = text}
                                        onChange={this.handleChange}
                                        value={this.state.marcas.comentario}
                                        maxLength={500}
                                        rows={this.state.rows}
                                        type="text"
                                        name="comentarios"
                                    />
                                </div>
                            </div>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                {/*<label className="col-sm-2 control-label">¿Se genera deterioro?</label>
                                <div className="col-sm-4">
                                    <input type="checkbox" className="form-control" placeholder="Auditoria"
                                        value={this.state.marcas.deterioro} onChange={this.onDeterioroChange}
                                    />
                                </div>*/}
                                {this.state.deterioro && <label className="col-sm-2 control-label">Cant. Deterioros</label>}
                                <div className="col-sm-3">
                                    {this.state.deterioro && 
                                        <input type="number" max={100} min={1} className="form-control" placeholder="Cantidad de Deterioros"
                                            value={this.state.cantDeterioros} onChange={this.onCantDeterioroChange}
                                        />
                                    }
                                </div>
                            </div>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                {this.state.deterioro && 
                                    this.state.deterioros.map((deterioro)=>
                                        <div key={deterioro.id} className="col-sm-4">
                                            <input type="text" className="form-control" placeholder="SKU"
                                                id={deterioro.id} value={deterioro.sku} onChange={this.onSKUChange}
                                            />
                                        </div>                                        
                                    )
                                }
                            </div>
                            <div className={cx("col-md-12 col-sm-12 form-group", 'form__control-label')}>
                                {this.state.deterioro &&
                                    <div className="col-sm-4">
                                        <label className="col-sm-2 control-label">¿Cancelado?</label>
                                        <input type="checkbox" className="form-control" placeholder="Cancelado"
                                            value={this.state.cancelado} onChange={this.onCanceladoChange}
                                        />
                                    </div>
                                }
                            </div>
                            <div className={cx("col-md-10 form-group", 'form__control-label')}>
                                <button className={cx("col-md-6 btn btn-block btn-primary", 'btn-50-perc')} type="submit" disabled={this.state.enviando}>{this.state.enviando? 'Enviando Reporte' : 'Enviar Reporte'}</button>
                                <a className={cx("col-md-4 btn btn-block btn-default", 'btn-50-perc')} href="#" onClick={this.state.enviando? null : this.props.hideModal}>Cancelar</a>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}
ModalReporteFinal.contextTypes = {
    nuevaMarca: PropTypes.func,
    descripcionReportes: PropTypes.func,
    nuevoAnexoMarca: PropTypes.func
}
const SelectorComentarioPrimero = ({idComentario, comentarioChange, comentarios})=>
    <div className="col-sm-12 form-group ">
        <select className="form-control"
                value={idComentario}
                onChange={comentarioChange}
        >
            <option key={"--"} value={"--"}>Seleccione comentario</option>
            {comentarios.map(comentario=>
                <option key={comentario.idDescripcionReportes} value={comentario.idDescripcionReportes}>{`${comentario.tituloDescripcion}`}</option>
            )}
        </select>
    </div>


// WEBPACK FOOTER //
// ./frontEnd/api/reportes/Modales.jsx